import React from 'react';

const MessageBubble = ({ message, isOwn }) => {
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`message-bubble ${isOwn ? 'message-bubble--sent' : 'message-bubble--received'}`}>
      <div className="message-bubble__content">
        {message.content}
      </div>
      <div className="message-bubble__meta">
        <span className="message-bubble__time">{formatTime(message.created_at)}</span>
        {isOwn && message.read_at && (
          <span className="message-bubble__read">Read</span>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
